export default __webpack_public_path__ + "static/media/excelFileIcon.756154dc.svg";